
      var _rect, _g, _ellipse, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInstagramBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 77,
  height: 76,
  viewBox: "0 0 77 76",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 24.057,
  y: 22,
  width: 28,
  height: 28,
  rx: 8,
  stroke: "#000",
  strokeWidth: 2
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#instagram-black_13a621d4e47deecd__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.02 29c3.88 0 7.021 3.136 7.021 7s-3.14 7-7.02 7C34.14 43 31 39.864 31 36s3.14-7 7.02-7Z",
  stroke: "#000",
  strokeWidth: 2,
  shapeRendering: "crispEdges"
}))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.036,
  cy: 28,
  rx: 2.005,
  ry: 2,
  fill: "#000"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "instagram-black_13a621d4e47deecd__a",
  x: 0,
  y: 0,
  width: 76.041,
  height: 76,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20951_7202"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20951_7202",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"77\" height=\"76\" viewBox=\"0 0 77 76\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<rect x=\"24.0566\" y=\"22\" width=\"28\" height=\"28\" rx=\"8\" stroke=\"black\" stroke-width=\"2\"/>\r\n<g filter=\"url(#filter0_d_20951_7202)\">\r\n<path d=\"M38.0205 29C41.9002 29 45.041 32.1364 45.041 36C45.041 39.8636 41.9002 43 38.0205 43C34.1408 43 31 39.8636 31 36C31 32.1364 34.1408 29 38.0205 29Z\" stroke=\"black\" stroke-width=\"2\" shape-rendering=\"crispEdges\"/>\r\n</g>\r\n<ellipse cx=\"46.0364\" cy=\"28\" rx=\"2.00512\" ry=\"2\" fill=\"black\"/>\r\n<defs>\r\n<filter id=\"filter0_d_20951_7202\" x=\"0\" y=\"0\" width=\"76.041\" height=\"76\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"2\"/>\r\n<feGaussianBlur stdDeviation=\"15\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_20951_7202\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_20951_7202\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/instagram-black.13a621d4e47deecd6a92ba5047c2b21d.svg"),
        {
          React: SvgInstagramBlack,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      